import { totalInvestmentIncome } from "./net_investment_income_tax";
import { TaxScenario } from "./tax_scenario";

export function totalIncome(taxScenario: TaxScenario): number {
  return taxScenario.wages + taxScenario.otherIncome + totalInvestmentIncome(taxScenario);
}
